import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '@app/data';
import { Observable } from 'rxjs';

import { ParentRoute, ABOUT } from '@app/constants';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,    
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {

  public routes$: Observable<ParentRoute[]> = this.data.getRoutes$();
  public about$: Observable<any[]> = this.data.about$;
  public about = ABOUT;

  constructor(
  	private data: DataService
  ) { }

  ngOnInit(): void {
  }

}
